import React, { Component } from 'react'
import PropTypes from 'prop-types'

class EventStageCreateModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      errorMessage: ''
    }

    this.input = React.createRef()
  }

  componentDidMount() {
    this.input.current.focus()
  }

  addNewEvent = (e) => {
    e.preventDefault()

    const { title } = this.state

    if (!title) {
      this.setState({errorMessage: "Please insert title"})
    } else {
      this.props.createEventStage({title})
      this.props.setModal(false)
    }
  }

  render() {
    const { title } = this.state

    return (
      <div className="modal-content">
        <h3>Add a stage</h3>

        <form onSubmit={this.addNewEvent}>
          <ul data-error-msg={this.state.errorMessage}>
            <li data-title="Stage name">
              <input ref={this.input}
                type="text"
                className="input--light"
                value={title}
                onChange={(e) => this.setState({title: e.target.value})} />
            </li>
          </ul>

          <button className="button--success" type="submit">Add stage</button>
        </form>
      </div>
    )
  }
}

EventStageCreateModal.propTypes = {
  createEventStage: PropTypes.func,
  setModal: PropTypes.func
}

EventStageCreateModal.defaultProps = {
  createEventStage: function() {},
  setModal: function() {}
}

export default EventStageCreateModal



// WEBPACK FOOTER //
// ./src/components/modals/event-stage-create-modal.js